import callApi from '../../util/apiCaller';

import { setIsFetching, FETCH_LIMIT, getItemsRequest } from '../App/AppActions';
import { addError } from '../Error/ErrorActions';

// Export Constants
export const SET_PROCESSES = 'SET_PROCESSES';
export const SET_PROCESS = 'SET_PROCESS';

export function getProcessesRequest(search = '', filters = null, sorter = null, pager = null) {
    return dispatch => dispatch(getItemsRequest('processes', null, items => dispatch(setProcesses(items)), { search, filters, sorter, pager }));
}

export function getProcessByTargetRequest(targetType, targetId) {
    return dispatch => {
        return callApi(`process/${targetType}/${targetId}`).then(result => {
            // dispatch(setProcesses(result.processes));
            return result.processes;
        }).catch(err => {
            return null;
        });
    };
}

export function editProcessRequest(process) {
    return dispatch => {
        return callApi('process/edit', 'post', { process }).then(result => {
            dispatch(getProcessesRequest());
            return result.process;
        }).catch(err => {
            return null;
        });
    };
}

export function relaunchProcessRequest(processId) {
    return dispatch => {
        return callApi('process/relaunch', 'post', { process: { _id: processId } }).then(result => {
            dispatch(getProcessesRequest());
            return result.process;
        }).catch(err => {
            return null;
        });
    };
}

export function relaunchAllProcessesRequest() {
    return dispatch => {
        return callApi('process/relaunch/all').then(result => {
            dispatch(getProcessesRequest());
            return result.ok;
        }).catch(err => {
            return null;
        });
    };
}

export function clearProcessesRequest(days = 10) {
    return dispatch => {
        return callApi(`process/clear/${days}`, 'delete').then(result => {
            dispatch(getProcessesRequest());
            return result;
        }).catch(err => {
            return null;
        });
    };
}

// Getters
export function getProcesses(store) {
    return store.processes.data;
}

export function getProcessesByTarget(store, type, id) {
    return store.processes.data.filter(process => process.data[type] && process.data[type]._id === id);
}

export function getProcess(store, id) {
    return store.processes.data.find(process => process._id === id);
}

export function getAvailableProcessStatuses() {
    return ['pending', 'tolaunch', 'onprogress', 'complete', 'error'];
}

export function getProcessStatusIcon(status) {
    switch(status) {
        case 'complete':
            return 'check-circle';

        case 'onprogress':
            return 'spinner';

        case 'tolaunch':
            return 'play';

        case 'error':
            return 'times-circle';

        case 'pending':
        default:
            return 'pause-circle';
    }
}

export function getProcessStatusColor(status) {
    switch(status) {
        case 'complete':
            return 'success';

        case 'onprogress':
            return 'info';

        case 'error':
            return 'danger';

        case 'tolaunch':
        case 'pending':
        default:
            return 'secondary';
    }
}

// Export Actions
export function setProcesses(processes) {
    return {
        type: SET_PROCESSES,
        processes,
    };
}
export function setProcess(process) {
    return {
        type: SET_PROCESS,
        process,
    };
}
